module.exports = __webpack_public_path__ + "static/media/illustration_chosen.0fabab2f.svg";